<!--
  Sub-modale "Conferma scatole" — terzo step wizard picking (v2.11.0 J.4.a).
  Diakonix native modal pattern (z-index 2100).
-->
@if (openedBox) {
  <div class="cb-backdrop" (click)="close()">
    <div
      class="cb-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cb-title"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <header class="cb-header">
        <div class="cb-title-block">
          <h2 id="cb-title">📦 Imballaggio</h2>
          @if (order?.or_order_number) {
            <p class="cb-subtitle">
              Ordine n° <strong>{{ order.or_order_number }}</strong> ·
              <strong>{{ orderToUpdate.boxes.length }}</strong> {{ orderToUpdate.boxes.length === 1 ? 'collo' : 'colli' }}
            </p>
          }
        </div>
        <button
          type="button"
          class="cb-close"
          aria-label="Chiudi"
          (click)="close()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <!-- Body -->
      <div class="cb-body">
        @if (loading) {
          <div class="cb-loading">
            <i class="bx bx-loader-alt bx-spin"></i>
            Caricamento colli...
          </div>
        } @else if (orderToUpdate.boxes.length === 0) {
          <div class="cb-empty">
            <div class="cb-empty__icon">📭</div>
            <p>Nessun collo aggiunto. Clicca "Aggiungi" per cominciare.</p>
          </div>
        } @else {
          <div class="cb-table">
            <div class="cb-table-head">
              <div class="cb-th cb-th--box">Collo</div>
              <div class="cb-th cb-th--toggle">Viteria</div>
              <div class="cb-th cb-th--toggle">Documenti</div>
              <div class="cb-th cb-th--toggle">Prodotti</div>
              <div class="cb-th cb-th--toggle">Rimuovi</div>
            </div>

            <div class="cb-table-body">
              @for (box of orderToUpdate?.boxes; track box.box_order_id || $index; let i = $index) {
                <div class="cb-row">
                  <div class="cb-td cb-td--box">
                    @if (box.ts_box_type_desc) {
                      <span class="cb-box-name">{{ box.ts_box_type_desc }}</span>
                    } @else {
                      <button
                        type="button"
                        class="cb-box-custom"
                        title="Dimensioni custom — clicca per modificare"
                        (click)="showBoxDetails(box, i)"
                      >Custom</button>
                    }
                  </div>

                  <div class="cb-td cb-td--toggle">
                    <label class="cb-checkbox">
                      <input
                        type="checkbox"
                        [checked]="isBoxScrewsChecked(box)"
                        (click)="addScrewsToBox(i)"
                      />
                      <span class="cb-checkmark"></span>
                    </label>
                  </div>

                  <div class="cb-td cb-td--toggle">
                    <label class="cb-checkbox">
                      <input
                        type="checkbox"
                        [checked]="isBoxDocumentsChecked(box)"
                        (click)="addDocumentsToBox(i)"
                      />
                      <span class="cb-checkmark"></span>
                    </label>
                  </div>

                  <div class="cb-td cb-td--toggle">
                    <button
                      type="button"
                      class="cb-icon-btn cb-icon-btn--products"
                      title="Lista prodotti per questo collo"
                      aria-label="Lista prodotti per questo collo"
                      (click)="seeListOfProducts(box)"
                    >
                      <i class="bx bxs-package"></i>
                    </button>
                  </div>

                  <div class="cb-td cb-td--toggle">
                    <button
                      type="button"
                      class="cb-icon-btn cb-icon-btn--remove"
                      title="Rimuovi collo"
                      aria-label="Rimuovi collo"
                      (click)="removeBox(i)"
                    >
                      <i class="bx bxs-trash"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <!-- Footer -->
      <footer class="cb-footer">
        <button
          type="button"
          class="cb-btn cb-btn--add"
          (click)="goToBox(clickedBox)"
        >
          <i class="bx bx-plus-circle"></i>
          Aggiungi collo
        </button>
        <button
          type="button"
          class="cb-btn cb-btn--print"
          (click)="printAllLabels()"
        >
          <i class="bx bx-printer"></i>
          Etichette
        </button>
        <button
          type="button"
          class="cb-btn cb-btn--save"
          (click)="saveStep('boxes')"
        >
          <i class="bx bx-check-circle"></i>
          Salva
        </button>
      </footer>
    </div>
  </div>
}

<!-- Sub-modali nested -->
@if (closeServ.isBoxOpn) {
  <app-add-box
    (dataInfo)="addBox($event)"
    [openBox]="closeServ.isBoxOpn"
    [box_type_id]="clickedBox"
  ></app-add-box>
}

@if (closeServ.isBoxDetOn) {
  <app-box-details
    (dataInfo)="updateCustomBox($event)"
    [openBox]="closeServ.isBoxDetOn"
    [box]="clickedBox"
    [boxNo]="boxNu"
  ></app-box-details>
}

@if (closeServ.isListOfProductsForBoxes) {
  <app-list-of-products-for-boxes
    [selectedBoxToAddProducts]="selectedBoxToAddProducts"
    [order]="this.order"
    [openedProductsListBoxes]="closeServ.isListOfProductsForBoxes"
    (modalClosed1)="this.bigRefresh()"
  ></app-list-of-products-for-boxes>
}
